import React, { useMemo } from "react"
import PropTypes from "prop-types"
import splitLines from "split-lines"

function MultiLineText({ children }) {
  const lines = useMemo(() => {
    if (children && typeof children === "string") {
      return splitLines(children)
    }
    return []
  }, [children])

  return (
    <>
      {lines.map(line => (
        <React.Fragment key={line}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </>
  )
}
MultiLineText.propTypes = {
  children: PropTypes.string,
}

export default MultiLineText
